import angular from 'angular';

angular
  .module('cloudX')
  .controller('ChangeRelTypeDialogCtrl', [
    'flySvc',
    'relBindSvc',
    'resourceFactorySvc',
    'appSettings',
    '$element',
    'close',
    'relId',
    'options',
    ChangeRelTypeDialog,
  ]);

function ChangeRelTypeDialog(
  flySvc,
  relBindSvc,
  resourceFactorySvc,
  appSettings,
  $element,
  close,
  relId,
  options,
) {
  var vm = this;
  vm.saving = false;
  vm.relation = angular.copy(relBindSvc.relations[relId]);
  vm.options = angular.extend(
    {
      relType: vm.relation.type,
      crmType: vm.relation.crm,
      country: vm.relation.country || appSettings.defaultCountry,
      relTypeDisabled: false,
      crmTypeDisabled: false,
      countryDisabled: false,
    },
    options || {},
  );
  vm.relType = vm.options.relType;
  vm.crmType = vm.options.crmType;
  vm.country = vm.options.country;
  vm.fields = [];
  var showError = function(error) {
    vm.saving = false;
    flySvc.error(error.data.code, error.data.parameters);
  };

  vm.change = function() {
    vm.fields = [];
    vm.formReady = false;
    if (vm.relType !== null && vm.crmType !== null && vm.country) {
      vm.relation['04c56e09-eeff-4982-a243-0688b6f45a74'].value = vm.country;
      vm.relation['8e18c532-ed32-49b5-bd7b-1c5529c38d15'].value = vm.crmType;
      vm.relation['ef5606cf-21ec-4de9-97f2-71a9d8192748'].value = vm.relType;

      resourceFactorySvc.get('fieldRequired').query(
        {
          type: vm.relType,
          crm: vm.crmType,
          country: vm.country,
        },
        function(fields) {
          vm.fields = [];
          for (var i = 0; i < fields.length; i++) {
            var field = fields[i];
            if (field.id === '04c56e09-eeff-4982-a243-0688b6f45a74') continue; //Country
            if (field.id === '8e18c532-ed32-49b5-bd7b-1c5529c38d15') continue; //Crm type
            if (field.id === 'ef5606cf-21ec-4de9-97f2-71a9d8192748') continue; //Relation type
            if (field.id === 'e31bb7ad-afb4-4a37-bd1e-46d4a9a71cf0') continue; //Own Company
            if (!vm.relation[field.id])
              vm.relation[field.id] = {
                value: null,
                type: field.type,
              };
            vm.fields.push({
              definition: field,
              value: vm.relation[field.id].value,
            });
          }
          vm.formReady = true;
        },
        showError,
      );
    }
  };

  vm.change();
  vm.save = function() {
    if (vm.saving) return;
    vm.saving = true;
    resourceFactorySvc.get('relation').changeType(
      {
        id: relId,
      },
      {
        relationType: vm.relType,
        crmType: vm.crmType,
        countryCode: vm.country,
        fields: vm.fields,
      },
      function() {
        vm.saving = false;
        close(true, 500);
        $element.modal('hide');
      },
      showError,
    );
  };

  vm.cancel = function() {
    close(null, 500);
  };
}
